import { FormButton } from "../../../components/_input/_button";
import BackHeading from "../../../components/backHeading";
import { useEffect, useState, useCallback } from "react";
import config from '../../../configuration/config.json'
import axios from "axios";
import { toast } from "react-toastify";
import { useTranslation } from "react-i18next";
import Skeleton from 'react-loading-skeleton'
import { getData, saveData, User_Data_Key } from "../../../utils/localStorageManager";
function BranchlessSelection({ submitRequest }) {
    const languageDir = 'language-' + localStorage.getItem('i18nextLng');
    const { t: trans, i18n } = useTranslation(["mobileHeading", "new", 'error']);
    const [data, setData] = useState(null);
    const [isLoadingBranches, setLoadingBranches] = useState(true);
    const [Branches, setBranches] = useState([]);
    useEffect(() => {
        GetBranch()


    }, []);

    async function GetBranch() {

        setLoadingBranches(true);
        let currentItems = [];
        console.log('GetBranch');
        try {
            currentItems = JSON.parse(getData('BRANCH', false));
            console.log('GetBranch currentItems:', currentItems);

            if (currentItems) {
                setBranches(currentItems);
                setLoadingBranches(false);

            } else {
                await axios.request({
                    url: config.controllerUrl + 'api/Branches/GetBranches',
                    method: "POST", responseType: "json"
                })
                    .then(function (response) {

                        const result = response.data;
                        console.log('site_FetchBranches response', result);

                        setBranches(result);
                        setLoadingBranches(false);
                        saveData('BRANCH', JSON.stringify(result), false);
                    })
                    .catch(function (error) {
                        console.log(error);
                        setLoadingBranches(false);
                    });
            }

        } catch (error) {

            await axios.request({
                url: config.controllerUrl + 'api/Branches/GetBranches',
                method: "POST", responseType: "json"
            })
                .then(function (response) {

                    const result = response.data;
                    console.log('site_FetchBranches response', result);

                    setBranches(result);
                    setLoadingBranches(false);
                    saveData('BRANCH', JSON.stringify(result), false);
                })
                .catch(function (error) {
                    console.log(error);
                    setLoadingBranches(false);
                });
        }

    };

    return (
        <div className={`branch-selection-page container mb-32 nice-apply-theme `}>

            {/* <BackHeading title={' استلام من فرع'} /> */}


            <div className="branch-selection-body nice-apply-theme">



                {
                    isLoadingBranches ? (

                        <>

                            <div className="container my-10 text-center nice-apply-theme">

                                <Skeleton count={3} borderRadius={"2rem"}
                                    width={"100%"} height={"25rem"} containerClassName={""}
                                    className={"my-5"} inline={false} />

                            </div>

                        </>
                    ) : (
                        Branches?.map((Branche, index) => {
                            return (

                                <article key={index} className="branch-selection-part flex flex-col nice-container">
                                    <div className=" my-5 flex flex-row nice-gap-1rem">
                                        <label className="text-20 font-bold flex flex-row nice-gap-1rem mb-b">
                                            <input type='radio' name='branchGroup'

                                                onClick={() => {
                                                    setData(Branche);

                                                }} />{Branche?.Address}</label>


                                    </div>
                                    <div className=" my-5 flex flex-row nice-gap-1rem">
                                        <span className="text-20">{trans("new:branch")}</span>
                                        <span className="text-20 ">{Branche[`${trans("mobileModel:description2")}`]}</span>
                                    </div>
                                    <div className="  my-5 flex flex-row nice-gap-1rem">
                                        <span className="text-20">{trans("mobileHeading:work_time")}</span>
                                        <span className="text-20 ">{Branche.WorkingHoursFormat}</span>
                                    </div>

                                    <div className=" my-5  flex flex-row items-center nice-gap-2rem">
                                        <a className="flex flex-row items-center nice-gap-2rem" target='_blank' href={`https://www.google.com/maps/?q=${Branche.Latitude},${Branche.Longitude}`}>
                                            <span className="text-20 text-primary">{trans("new:map")}</span>
                                            <img src="/assets/icons/location.svg" className="filter-primary nice-width-max-80 nice-height-max-80 object-contain" />
                                        </a>
                                    </div>
                                </article>

                            );
                        })

                    )
                }



            </div>


            <FormButton name={trans("new:continue")}
                //  isLoading={isLoading} 
                onClick={() => {
                    if (data) {
                        if (submitRequest)
                            submitRequest(data);
                    }
                }}
            />

        </div >
    );
}

export default BranchlessSelection;
